export default __webpack_public_path__ + "static/hover-dont-d7836ee2103386e3d5d72a10fa8686c2.png";